export default {
  playable: {
    label: '可玩项目',
    projectInfo: '推广产品信息（用于CTA跳转及加载页面）',
    delete: '删除项目',
    startCreate: '想要快速开始可玩广告制作？',
    messageDes: '试着利用Playturbo提供的模板开始创作您的第一个可玩广告创意吧！',
    describe:
      '元素级可玩广告制作平台，覆盖各大广告网络平台，支持一键打包或自由选择下载。',
    choice: '选择模板',
    create: {
      name: '新建项目',
      template: '选择模板',
      blank: '自由编辑器',
      iv: '视频转可玩',
    },
    filter: {
      projectname: '项目名称',
      projectid: '项目ID',
      projectstatus: '项目状态',
      edittime: '更新时间',
      createtime: '创建时间',
    },
    table: {
      project: '项目名称及ID',
      productname: '产品名称',
      Status: '项目状态',
      demoTip: '该项目为demo项目，已置顶。',
      edittips: '编辑',
      previewtips: '预览',
      applytips: '推送至Mintegral',
      downloadtips: '下载',
      packChannel: '打包渠道',
      pushFolder: '推送文件夹',
      detail: '查看详情',
    },
    more: '更多',
    moretemplates: '查看更多模板',
    editProjectConfirm: {
      title: '编辑',
      desc: '该项目为demo项目，不可编辑。',
    },
    delProjectConfirm: {
      title: '删除',
      desc: '该项目为demo项目，不可删除。',
    },
    detail: {
      templateName: '模板名称',
      direction: '适配方向',
    },
    resetProjectLabel: '重置Demo项目',
    resetProjectConfirm: {
      title: '重置Demo项目',
      desc: '是否确认重置Demo项目？',
      error: '该Demo项目无需重置',
      success: 'Demo项目重置成功',
      fail: 'Demo项目重置失败',
    },
  },
}
